import "./style.css";
const Privacy = () => {
	return (
		<div className="privacy" id="Privacy">
			<div className="container">
				<p className="title">Our Privacy policy </p>
				<p className="description">
					By using the FM 90 Valet System, you agree to the terms of this
					Privacy Policy. 1. Information We Collect We may collect the following
					types of information when you use the App: a. Personal Information
					Name, phone number, and email address Vehicle information (model,
					license plate, color, etc.) Payment details (processed securely
					through third-party payment gateways)
				</p>
			</div>
		</div>
	);
};
export default Privacy;
